import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { GourmetoWordmark } from "./brand/GourmetoLogo";
import AppMenu from "./AppMenu";
import LangToggle from "./LangToggle";
import { useLanguage } from "../contexts/LanguageContext";

const NAV = [
  { to: "/map", key: "nav.discover" },
  { to: "/pool", key: "nav.pools" },
  { to: "/favourites", key: "nav.lists" },
  { to: "/profile", key: "nav.profile" },
];

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const home = location.pathname === "/" || location.pathname === "/homePage";
  const canGoBack = !home;

  return (
    <StyledHeader>
      <Left>
        {canGoBack ? (
          <IconBtn className="mobile-only" type="button" onClick={() => navigate(-1)} aria-label={t("nav.back")}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path
                d="M15 18l-6-6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconBtn>
        ) : null}
        <Brand type="button" onClick={() => navigate("/homePage")}>
          <GourmetoWordmark size={34} />
        </Brand>
      </Left>

      <DesktopNav aria-label={t("nav.primary")}>
        {NAV.map((item) => (
          <NavLink key={item.to} to={item.to}>
            {t(item.key)}
          </NavLink>
        ))}
      </DesktopNav>

      <Right>
        <IconBtn
          type="button"
          className="desktop-only"
          onClick={() => navigate("/map")}
          aria-label={t("nav.searchMap")}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
            <path d="M20 20l-3.2-3.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </IconBtn>
        <LangToggle variant="header" />
        <AppMenu variant="header" />
        <Cta className="desktop-only" type="button" onClick={() => navigate("/favourites")}>
          {t("nav.startPool")}
        </Cta>
      </Right>
    </StyledHeader>
  );
};

export default Header;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: var(--content-max);
  margin: 0 auto;

  @media (min-width: 1024px) {
    .mobile-only {
      display: none;
    }
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const Brand = styled.button`
  border: none;
  background: none;
  color: currentColor;
  padding: 0;
  display: inline-flex;
  align-items: center;
`;

const DesktopNav = styled.nav`
  display: none;
  align-items: center;
  gap: 28px;

  a {
    text-decoration: none;
    color: var(--ink-soft);
    font-size: 14px;
    font-weight: 500;
  }

  a.active,
  a:hover {
    color: var(--ink);
  }

  @media (min-width: 1024px) {
    display: flex;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .desktop-only {
    display: none;
  }

  @media (min-width: 1024px) {
    .desktop-only {
      display: inline-flex;
    }
    .mobile-only {
      display: none;
    }
  }
`;

const IconBtn = styled.button`
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 1px solid currentColor;
  border-radius: 50%;
  color: inherit;
`;

const Cta = styled.button`
  border: none;
  background: var(--color-yellow);
  color: var(--color-ink-solid);
  border-radius: var(--radius-pill);
  padding: 10px 16px;
  font-weight: 600;
  font-size: 13px;
  min-height: 40px;
  align-items: center;
`;
